/**
 * Export system types
 */

export interface ExportSettings {
    format: 'mp4' | 'webm'
    resolution: {
        width: number
        height: number
    }
    frameRate: number
    videoBitrate: number // bits per second
    audioBitrate: number // bits per second
    includeAudio: boolean
}

export interface ExportProgress {
    stage: 'initializing' | 'rendering' | 'audio' | 'finalizing' | 'complete' | 'error'
    progress: number // 0-100
    currentFrame: number
    totalFrames: number
    estimatedTimeRemaining: number // seconds
    message?: string
}

export interface ExportPreset {
    name: string
    description: string
    settings: Partial<ExportSettings>
}

export const EXPORT_PRESETS: ExportPreset[] = [
    {
        name: 'Quick (720p)',
        description: 'Fast for social media sharing',
        settings: {
            resolution: { width: 1280, height: 720 },
            frameRate: 30,
            videoBitrate: 4_000_000,
            audioBitrate: 128_000,
        }
    },
    {
        name: 'Standard (1080p)',
        description: 'Great for YouTube and web',
        settings: {
            resolution: { width: 1920, height: 1080 },
            frameRate: 30,
            videoBitrate: 10_000_000,
            audioBitrate: 192_000,
        }
    },
    {
        name: 'High (1080p)',
        description: 'Smooth 60fps cinematic',
        settings: {
            resolution: { width: 1920, height: 1080 },
            frameRate: 60,
            videoBitrate: 15_000_000,
            audioBitrate: 256_000,
        }
    },
    {
        name: 'Maximum (4K)',
        description: 'Ultra high resolution and quality',
        settings: {
            resolution: { width: 3840, height: 2160 },
            frameRate: 60,
            videoBitrate: 25_000_000,
            audioBitrate: 320_000,
        }
    }
]

export const DEFAULT_EXPORT_SETTINGS: ExportSettings = {
    format: 'mp4',
    resolution: { width: 1920, height: 1080 },
    frameRate: 30,
    videoBitrate: 8_000_000,
    audioBitrate: 192_000,
    includeAudio: true,
}
